// frontend/src/layouts/MainLayout.tsx
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import GlobalHeader from "../components/GlobalHeader";
import { useSidebarStore } from "../store/sidebarStore";

export default function MainLayout() {
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    return (localStorage.getItem("admin-dashboard-theme") as "dark" | "light") || "dark";
  });
  const { isCollapsed } = useSidebarStore();

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("admin-dashboard-theme", newTheme);
  };

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.add("light-theme");
      document.documentElement.classList.remove("dark");
    } else {
      document.body.classList.remove("light-theme");
      document.documentElement.classList.add("dark");
    }
  }, [theme]);

  // Sync sidebar width CSS variable on HTML root
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--sidebar-w",
      isCollapsed ? "76px" : "264px"
    );
  }, [isCollapsed]);

  return (
    <div className={`app-layout ${isCollapsed ? "sidebar-is-collapsed" : ""}`}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main area */}
      <main className="main-area flex-1 min-w-0">
        {/* Global Header */}
        <GlobalHeader theme={theme} onToggleTheme={toggleTheme} />

        {/* Page content */}
        <div className="flex-1 min-w-0 overflow-y-auto relative" style={{ display: 'flex', flexDirection: 'column' }}>
          <Outlet context={{ theme, toggleTheme }} />
        </div>
      </main>
    </div>
  );
}
